import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmployeeService } from '@lmc-app/core/services/employee.service';
import { SideBarDef } from 'ag-grid-community';
import { ButtonCellRendererComponent } from '@lmc-app/custom-table/button-cell-renderer/button-cell-renderer.component';
import { ResetPasswordModalComponent } from './reset-password-modal/reset-password-modal.component';

@Component({
	selector: 'app-accounts',
	templateUrl: './accounts.component.html',
	styleUrls: ['./accounts.component.scss'],
})
export class AccountsComponent implements OnInit {
	public sideBar: SideBarDef | string | string[] | boolean | null;
	columns = [
		{
			headerName: 'ID',
			field: 'employee_id',
			sortable: true,
			autoHeight: true,
		},
		{
			headerName: 'Name',
			field: 'full_name',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
		},
		{
			headerName: 'Email',
			field: 'email',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
		},
		{
			headerName: 'Position',
			field: 'position',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
		},
		{
			headerName: 'Role',
			field: 'role',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
		},
		{
			headerName: 'Status',
			field: 'employee_status',
			sortable: true,
			autoHeight: true,
			valueFormatter: params => params.value ? "Active" : "Inactive",
		},
		{
			headerName: 'Last login',
			field: 'last_logged_in',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
			valueFormatter: params => {
				if (params.value) {
					return new Date(params.value).toLocaleDateString('en-US', {
						year: 'numeric',
						month: 'short',
						day: 'numeric',
						hour: '2-digit',
						minute: '2-digit',
						second: '2-digit',
						hour12: true
					});
				}
				return '';
			},
		},
		{
			headerName: 'IP address',
			field: 'ip_address',
			sortable: true,
			filter: 'agTextColumnFilter',
			autoHeight: true,
		},
		{
			headerName: 'Edit',
			cellRenderer: ButtonCellRendererComponent,
			cellRendererParams: {
				label: 'Edit',
				matIconLabel: 'edit	',
				clicked: (params: any) => {
					this.router.navigate([`/admin-settings/account/update/${params.employee_id}`]);
				},
			}
		},
		{
			headerName: 'Clone',
			cellRenderer: ButtonCellRendererComponent,
			cellRendererParams: {
				label: 'Clone',
				matIconLabel: 'content_copy',
				clicked: (params: any) => {
					console.log(params)
					this.router.navigate(
						[`/admin-settings/account/create`],
						{
							queryParams: {
								role_id: params.role_id,
								position: params.position,
								company_id: params.company_id,
								department_id: params.department_id,
							}
						}
					);
				},
			}
		},
		{
			headerName: 'Reset Password',
			cellRenderer: ButtonCellRendererComponent,
			cellRendererParams: {
				label: 'Reset Password',
				matIconLabel: 'lock_reset',
				clicked: (params: any) => {
					const requestData = {
						employee_id: params.employee_id,
					};
					this.dialog.open(ResetPasswordModalComponent, {
						height: '180px',
						width: '220px',
						autoFocus: true,
						data: requestData,
					});
				},
			}
		},
	];
	accounts: Employee[] = [];
	filteredAccounts: Employee[] = [];
	// Loading states
	isLoading: boolean = false;

	constructor(
		private employeeService: EmployeeService,
		private dialog: MatDialog,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.isLoading = true;
		this.getAccounts();
		this.setSummaryData();
	}

	getAccounts() {
		this.employeeService.getEmployees().subscribe({
			next: (res) => {
				this.accounts = res.map(employee => ({
					employee_id: employee.employeeID,
					role_id: employee.roleID,
					full_name: employee.full_name,
					email: employee.email,
					position: employee.position,
					role: employee.role.description,
					employee_status: employee.employee_status,
					company_id: employee.company_id,
					department_id: employee.department_id,
					last_logged_in: employee.last_logged_in,
					ip_address: employee.ip_address,
				})).sort((a, b) => b.employee_id - a.employee_id);
				this.filteredAccounts = this.accounts;
				this.isLoading = false;
			},
			error: (err) => {
				console.error(err);
				this.isLoading = false;
			},
		});
	}

	createAccount() {
		this.router.navigate([`admin-settings/account/create`]);
	}

	setSummaryData() {
		this.sideBar = {
			toolPanels: [
				{
					id: 'filters',
					labelDefault: 'Filters',
					labelKey: 'filters',
					iconKey: 'filter',
					toolPanel: 'agFiltersToolPanel',
				},
				{
					id: 'columns',
					labelDefault: 'Columns',
					labelKey: 'columns',
					iconKey: 'columns',
					toolPanel: 'agColumnsToolPanel',
					toolPanelParams: {
						suppressPivotMode: true,
						suppressValues: true,
						suppressRowGroups: true,
					},
				},
			],
			defaultToolPanel: 'customStats',
		};
	}
}
